import { TickMedium } from '@zoopla-eng/zds-components/icons';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import type { FC } from 'react';
import {
    attributeListItemStyle,
    attributeListStyle,
    attributeTextStyle
} from './premium-attributes.styles.css';

type PremiumAttributesProps = {
    attributes?: string[];
    type?: 'featured' | 'premium';
};

const PremiumAttributes: FC<PremiumAttributesProps> = ({
    attributes = [],
    type
}) =>
    type === 'premium' && attributes?.length > 0 ? (
        <ul className={`${attributeListStyle} ${fontGroups.fork}`}>
            {attributes.map((attribute) => (
                <li className={attributeListItemStyle} key={attribute}>
                    <TickMedium color="functionalSuccess" />
                    <span className={attributeTextStyle}>{attribute}</span>
                </li>
            ))}
        </ul>
    ) : null;

export { PremiumAttributes };
